import React from "react";
import AWS from "aws-sdk/global";
import S3 from "aws-sdk/clients/s3";
import moment from "moment";
import heic2any from "heic2any";

export default class ImageuploadPopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profileimage: "",
      imageUrl: "",
      errormsg: "",
      bucketUrl: null,
      canvasKey: null,
      originalKey: null,
    };
    this.initialize = this.initialize.bind(this);
    this.uploadToS3 = this.uploadToS3.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.handleReset = this.handleReset.bind(this); // Bind handleReset function
    AWS.config.region = "ap-south-1"; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: "ap-south-1:84027705-475d-4ca1-bac8-b2eb7407ae9f",
    });
    this.bucketname = "js-sdk-bucket";
    this.bucket = new AWS.S3({
      params: {
        Bucket: this.bucketname,
      },
    });
  }

  componentDidMount() {
    this.initialize();
  }

  initialize() {
    let date = moment().format("DD-MM-yyyy");
    var sessionid = Date.now();
    localStorage.setItem("sessionid", sessionid);

    var bucketUrl =
      "https://s3.ap-south-1.amazonaws.com/" + this.bucketname + "/";
    var canvasKey =
      "mkb_image_avatar/cmsuploads_" +
      localStorage.getItem("sessionid") +
      ".jpg";
    var originalKey =
      "mkb_image_avatar/" +
      date +
      "/" +
      "cmsuploads_" +
      localStorage.getItem("sessionid") +
      ".jpg";
    this.setState({
      originalKey: originalKey,
      canvasKey: canvasKey,
      bucketUrl: bucketUrl,
    });
  }

  reset() {
    this.initialize();
  }

  // handleimage = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     this.setState({ profileimage: file, imageUrl });
  //   }
  // };

  handleimage = (event) => {
    const file = event.target.files[0];
    if (file) {
      let fileType = file.type || ""; // Fallback to empty string if file.type is blank
      const fileExtension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      const validExtensions = [".jpeg", ".png", ".jpg"];

      // Check if fileType is valid, or if fileType is blank, check the extension
      if (
        validTypes.includes(fileType) ||
        validExtensions.includes(fileExtension)
      ) {
        const imageUrl = URL.createObjectURL(file);
        this.setState({ profileimage: file, imageUrl, errormsg: "" });
      } else {
        this.setState({
          profileimage: "",
          imageUrl: "",
          errormsg: "Please select a valid image file (JPEG, PNG, JPG).",
        });
      }
    }
  };

  handleimage_old = (event) => {
    const file = event.target.files[0];
    if (file) {
      const fileType = file.type;
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/heic",
        "image/jpg",
        "image/heif",
      ];
      const validExtensions = [".jpeg", ".png", ".heic", ".jpg", ".heif"];
      const fileExtension = file.name
        .substring(file.name.lastIndexOf("."))
        .toLowerCase();

      if (
        validTypes.includes(fileType) ||
        validExtensions.includes(fileExtension)
      ) {
        // Check if the file is HEIC
        if (fileType === "image/heic" || fileExtension === ".heic") {
          // Convert HEIC to JPG for preview
          heic2any({ blob: file, toType: "image/jpeg" })
            .then((convertedBlob) => {
              const imageUrl = URL.createObjectURL(convertedBlob);
              this.setState({ profileimage: file, imageUrl });
            })
            .catch((error) => {
              console.error("HEIC conversion failed", error);
              alert("Failed to preview HEIC image");
            });
        } else {
          const imageUrl = URL.createObjectURL(file);
          this.setState({ profileimage: file, imageUrl });
        }
      } else {
        alert("Only JPEG, PNG, HEIC, and JPG files are allowed.");
        this.setState({ profileimage: "", imageUrl: "" });
      }
    }
  };

  handleUpload() {
    const { profileimage } = this.state;
    console.log("profile", profileimage);
    if (profileimage) {
      this.uploadToS3(
        profileimage,
        "original",
        this.bucket,
        this.uploadCallback
      );
      this.props.flagpopup("1");
    } else {
      alert("No image selected for upload");
      console.error("No image selected for upload");
    }
  }

  uploadCallback = (err, data) => {
    if (err) {
      console.error("Upload failed:", err);
    } else {
      const imageUrl =
        `https://campaign-images.narendramodi.in/` + this.state.originalKey;
      this.props.getProfile(imageUrl);
      this.props.hideImgpopup();
      console.log("Upload successful. Image URL:", imageUrl);
    }
  };

  uploadToS3(file, type, bucket, callback) {
    let objKey = null;
    if (type === "canvas") {
      objKey = this.state.canvasKey;
    } else if (type === "original") {
      objKey = this.state.originalKey;
    }

    const params = {
      Key: objKey,
      ContentType: file.type,
      Body: file,
      ACL: "public-read",
    };

    bucket.putObject(params, callback || (() => {}));
  }

  handleReset() {
    this.setState({
      profileimage: "", // Reset image to empty
      imageUrl: "", // Reset imageUrl to show default
    });
    this.props.hideImgpopup();
  }

  render() {
    const { imageUrl, errormsg } = this.state;
    return (
      <>
        <div className="popup_pos">
          <div className="popup_bg">
            <div className="popup_content">
              <h5>Upload Image</h5>
              <div className="imgup_div">
                <img
                  src={imageUrl ? imageUrl : `/assets/images/userdefault2.jpg`}
                  className="userup_img"
                  alt="User Avatar"
                />
                <input
                  type="file"
                  accept="image/jpeg,image/png, image/jpg, image/heic"
                  // accept=".png, .jpeg, .jpg"
                  onChange={this.handleimage}
                />
                <button className="edit_btn">
                  <img src="/assets/images/edit.svg" alt="Edit" />
                </button>
              </div>

              <ul className="imgbtn_list">
                <li>
                  <button className="no_btn" onClick={this.handleReset}>
                    Not now
                  </button>
                </li>
                <li>
                  <button className="yes_btn" onClick={this.handleUpload}>
                    Upload
                  </button>
                </li>
              </ul>
              {errormsg && (
                <p
                  style={{
                    color: "red",
                    "font-size": "24px",
                    "margin-top": "20px",
                  }}
                >
                  {errormsg}
                </p>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
